import { type FilterValues } from "components/filters/FilterContext";
import { mapNotificationStatusFilterToInstruction, mapResponseToNotificationStatusFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListNotificationInstruction => ({
  channel: "browser",
  markAllSeen: true,
  notificationStatus: mapNotificationStatusFilterToInstruction(filter.notificationStatus),
  page,
  perPage,
  cache: filterSet,
});

export const mapResponseToFilterValues = (
  response: server.dto.ListNotificationFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  notificationStatus: mapResponseToNotificationStatusFilter(response.status),
});
